import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/feature/CookieConsent";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <Suspense>
          <AppRoutes />
        </Suspense>
        <CookieConsent />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
